import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { HeaderLink } from '@/types/header-link';
import { dataTestTransformer } from '@/utils/data-test-helper';

export const secondaryLinks: HeaderLink[] = [
  {
    href: '/gift-cards',
    title: 'Gift Cards',
    useAnchor: true,
  },
  {
    href: '/food-drink',
    title: 'Food & Drink',
    useAnchor: true,
  },
  {
    href: '/merchandise',
    title: 'Merchandise',
    useAnchor: true,
  },
  {
    href: '/private-events',
    title: 'Private Events',
    useAnchor: true,
  },
  {
    href: '/movie-news',
    title: 'Movie News',
    useAnchor: true,
  },
  {
    href: '/guest-services',
    title: 'Guest Services',
    useAnchor: true,
  },
];

export const SecondaryNavLinks = (): React.JSX.Element => {
  return (
    <ul className="hidden flex-row flex-wrap text-xs gap-3 justify-end lg:flex"
      data-test="secondary-links"
    >
      {secondaryLinks.map((item, index) =>
        <li key={index}
          className="list-item text-sm"
        >
          <CinemarkLink dataLinkCategory={AnalyticsPageCategories.SECONDARY_NAV}
            dataLinkName={item.title}
            dataTest={`secondary-link-${dataTestTransformer(item.title)}`}
            href={item.href}
            useAnchor={item.useAnchor}
          >
            {item.title}
          </CinemarkLink>
        </li>
      )}
    </ul>
  );
};
